import { QueryCache, QueryClient, MutationCache } from '@tanstack/react-query';
import toast from 'react-hot-toast';

export const STALE = {
  skills: 3_600_000,
  userProgress: 30_000,
  content: 30_000,
  static: 86_400_000,
  recommendations: 300_000,
  learningPath: 10_000,
  learningDashboard: 120_000,
  dashboard: 60_000,
  practiceHistory: 60_000,
  achievements: 30_000,
  analytics: 300_000,
  // Always refetch — counts shown in a confirm dialog must be fresh on open.
  fresh: 0,
};

function extractMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return 'Something went wrong. Please try again.';
}

function httpStatus(error: unknown): number | null {
  return (error as { response?: { status?: number } })?.response?.status ?? null;
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      const status = httpStatus(error);
      // 4xx errors carry business-logic meaning — local `isError` branches
      // (or recovery effects like DiagnosticAssessment's redirect) handle them.
      // Only surface unexpected server/network failures globally. Mirrors the
      // MutationCache policy below.
      if (status != null && status < 500) return;
      toast.error(extractMessage(error));
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      const status = httpStatus(error);
      // 4xx errors carry business-logic meaning — local onError handlers deal with them.
      // Only surface unexpected server/network failures globally.
      if (status != null && status < 500) return;
      toast.error(extractMessage(error));
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: STALE.userProgress,
      retry: 1,
    },
  },
});
